export const NO_CONECTION_TO_EDGE_DEVICE = 'No Connection to Edge Device';
export const LINES_CURRENTLY_UNAVAILABLE = 'currently unavailable.';
export const LINE = 'Line';
export const AVAILABLE_AGAIN_MULTI = 'are available again.';
export const AVAILABLE_AGAIN = 'is available again.';
export const AND = 'and';
export const CONNECTION_EDGE_DEVICE_RESTORED = 'Connection to EdgeDevice Restored:';
export const CONTACT_SUPPORT = 'Please contact support if this problem persists.';
